import React from 'react'

import PropTypes from 'prop-types'

import './branding.css'

const Branding = (props) => {
  return (
    <div className={`branding-branding ${props.rootClassName} `}>
      <span className="branding-text">{props.text}</span>
      <svg viewBox="0 0 1024 1024" className="branding-icon">
        <path d="M128 128h768v768h-768z" className=""></path>
      </svg>
      <span className="branding-text1">{props.text1}</span>
    </div>
  )
}

Branding.defaultProps = {
  rootClassName: '',
  text: 'SourcingSpace',
  text1: 'A Talent Sourcing Agency',
}

Branding.propTypes = {
  rootClassName: PropTypes.string,
  text: PropTypes.string,
  text1: PropTypes.string,
}

export default Branding
